import { Module } from 'vuex'
import { State } from '../index';
import { login, getUserProfile, logout } from '@/api/'
import store from 'store'
import { AxiosResponse } from 'axios';
import { Role, RoleName } from '@/enum/roles.enum'
import { updateAbility } from '@/casl/ability';
import { generateRoutesByUserRole } from '@/router';


// 定义user module
const user: Module<State, State> = {
  namespaced: true,
  state: {
    name: '',
    role: '',
    roleName: '',
    logo: '',
  },
  mutations: {
    setName(state, name: string) {
      state.name = name
    },
    setRole(state, role: Role) {
      state.role = role;
      state.roleName = RoleName[role]
    },
    setLogo(state, uuid: string) {
      state.logo = uuid;
    },
  },
  actions: {
    async login({ commit, dispatch }, loginForm: { username: string, password: string }) {
      await login(loginForm).then((res: AxiosResponse) => {
        const token = `Bearer ${res?.data?.access_token}`
        store.set('token', token);
      });
      await dispatch('getProfile')
    },
    async getProfile({ commit, dispatch }) {
      await getUserProfile().then((res: AxiosResponse) => {
        commit('setName', res.data.name);
        commit('setRole', res.data.role);
        // 获取用户关联的LOGO
        // 优先展示项目logo，缺省则显示企业logo
        commit('setLogo', res.data.project?.logo || res.data.company?.logo);

        // 根据用户角色生成对应的路由配置
        generateRoutesByUserRole(res.data.role);

        updateAbility(res.data?.role);
      })
    },
    async logout() {
      await logout().then(() => {
        store.remove('token')
      });
    },
  },
  getters: {
    user(state: State) {
      return {
        name: state.name,
        role: state.role,
      }
    }
  }
}

export default user